import PortailRequestController from './request.list.controller';

export default {
    controller: PortailRequestController,
    template: require('./request.list.tpl.html')
};
